<template>
  <div class="purchase-method-detail-file-info">
    <file-manage
      v-if="fileFuns.get"
      :file-data-ids="data.fileIds"
      @addFile="addFile"
      :funs="fileFuns"
      @delFile="delFile"></file-manage>
  </div>
</template>

<script>
import {
  askLeaveApplyRequest
} from '../../../api'

import FileManage from '@/components/base/FileManage'

export default {
  components: {
    FileManage
  },
  props: {
    data: { type: Object, defualt: () => null },
    fun: { type: Object, defualt: () => null }
  },
  computed: {
    fileFuns () {
      return this.fun || {
        get: this.$authFunsProxy.getDataFile,
        upload: this.$authFunsProxy.updateDataFile,
        del: this.$authFunsProxy.delDataFile
      }
    }
  },
  methods: {
    async addFile (data) {
      if (!this.data.fileIds.includes(data.id)) {
        this.data.fileIds.push(data.id)
        askLeaveApplyRequest.files(this.data.id, {
          fileIds: this.data.fileIds.join(',')
        })
      }
    },
    async delFile (data) {
      const index = this.data.fileIds.findIndex(v => data.id === v)
      if (index > -1) {
        this.data.fileIds.splice(index, 1)
        askLeaveApplyRequest.files(this.data.id, {
          fileIds: this.data.fileIds.join(',')
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.purchase-method-detail-file-info {
  
}
</style>